import httpClientImmigration from "@/services/httpClientImmigration";
import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getTransectionLog = () => {
  return httpClientImmigration.get(server.TRANSACTIONS_LOG);
};

export const getTransectionLogById = (id) => {
  return httpClientImmigration.get(server.TRANSACTIONS_LOG + `/${id}`);
};

export const addTransectionLog = (data) => {
  return httpClientImmigration.post(server.TRANSACTIONS_LOG, data);
};
export const addTransectionLogCoreApi = (data) => {
  return httpClient.post(server.TRANSACTIONS_LOG, data);
};

export const updateTransectionLog = (id, data) => {
  return httpClientImmigration.put(server.TRANSACTIONS_LOG + `/${id}`, data);
};

export const deleteTransectionLog = (id) => {
  return httpClientImmigration.delete(server.TRANSACTIONS_LOG + `/${id}`);
};

export const getTransectionLogByTable = () => {
  return httpClientImmigration.get(
    server.TRANSACTIONS_LOG + `/serach/data-table`,
  );
};
export const getTransectionLogByTableCoreApi = () => {
  return httpClient.get(
    server.TRANSACTIONS_LOG + `/serach/data-table`,
  );
};
export const getTransectionLogBySearch = (com_id, query) => {
  return httpClientImmigration.get(
    server.TRANSACTIONS_LOG + `/serach/data-all/${com_id}`,
    query,
  );
};

export const getTransectionLogBySearchPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id,
  table_name,
  action,
  department_id,
  datefrom,
  dateto,
  com_id,
) => {
  return httpClientImmigration.get(
    server.TRANSACTIONS_LOG + `/search/data-all-pagination/${com_id}`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        user_id,
        table_name,
        action,
        department_id,
        datefrom,
        dateto,
      },
    },
  );
};
export const getTransectionLogBySearchPaginationCoreApi = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id,
  table_name,
  action,
  department_id,
  datefrom,
  dateto,
  com_id,
) => {
  return httpClient.get(
    server.TRANSACTIONS_LOG + `/search/data-all-pagination/${com_id}`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        user_id,
        table_name,
        action,
        department_id,
        datefrom,
        dateto,
      },
    },
  );
};
